<template>
  <div>
    <div class="play-list" ref="playList">
      <div class="category-title">
        <div class="channel-avatar" :style="{ backgroundImage: `url(${category.iconUrl})` }"></div>
        <p>{{ category.name }}</p>
      </div>
      <div>
        <div v-for="video in categoryVideos"
          :key="video.id"
          :class="{ 'active' : video.id === videoId }"
          class="play-list-card"
          :ref="video.id === videoId ? 'activeVideo' : null"
          @click.stop="handleClickViewVideo(video)"
        >
          <div style="position: relative;">
            <div v-if="video.isTargetPremium" class="premium-badge">
              <i aria-hidden="true" class="fa fa-diamond"></i>
              プレミアム
            </div>
            <img :src="video.thumbnail" :alt="video.title" loading="lazy">
          </div>
          <div class="play-list-info">
            <div class="play-list-title">{{ video.title }}</div>
            <div class="flexbox gap-10 text-gray">
              <span> {{ video.createDate }}</span>
              <span>
                <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                {{ video.likes }}
              </span>
              <span>
                <i class="fa fa-comments-o" aria-hidden="true"></i>
                {{ video.comments }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="other-list" ref="otherList">
      <div class="other-list-header">
        <div class="chip-scroll-button" v-show="atStart" @click="scrollChips(-150)">
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
        </div>
        <div class="chip-scroll" ref="chipScroll">
          <button class="chip"
          :class="{ 'active': selectedCategory === 'TOP'}"
          @click="handleChangeCategory('TOP')"
          >
            TOP
          </button>
          <button
            v-for="c in categoriesOther"
            :key="c.id"
            class="chip"
            :class="{ 'active': selectedCategory === c.id}"
            @click="handleChangeCategory(c.id)"
          >
            {{ c.name }}
          </button>
        </div>
        <div class="chip-scroll-button" v-show="atEnd" @click="scrollChips(150)">
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </div>
      </div>
      <div class="video-list">
        <div
          class="video-item"
          v-for="video in categoryVideoOthers"
          :key="video.id"
          @click.stop="handleClickViewVideo(video)"
        >
          <div class="thumbnail-wrapper">
            <div v-if="video.isTargetPremium" class="premium-badge">
              <i aria-hidden="true" class="fa fa-diamond"></i>
              プレミアム
            </div>
            <img :src="video.thumbnail" :alt="video.title" loading="lazy" />
          </div>
          <div class="video-meta">
            <div class="video-title">{{ video.title }}</div>
            <div class="flexbox gap-10 text-gray">
              <span> {{ video.createDate }}</span>
              <span>
                <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                {{ video.likes }}
              </span>
              <span>
                <i class="fa fa-comments-o" aria-hidden="true"></i>
                {{ video.comments }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    categoryId: {
      type: Number
    },
    videos: {
      type: Array
    }
  },
  computed: {
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    },
    videoId () {
      return Number(this.$route.params.id)
    },
    categories () {
      return this.$store.getters.getCategories
    },
    category () {
      return this.categories.find(i => { return i.id === this.categoryId })
    },
    categoryVideos () {
      return this.videos.filter(i => { return i.category === this.categoryId })
    },
    topVideos () {
      return this.videos.slice(0, 5)
    },
    categoriesOther () {
      return [...this.categories].filter(i => { return i.id !== this.categoryId })
    }
  },
  data () {
    return ({
      loader: null,
      atStart: true,
      atEnd: false,
      selectedCategory: 'TOP',
      categoryVideoOthers: []
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.handleScroll()
    })
    this.categoryVideoOthers = this.topVideos
  },
  methods: {
    async sleep (time = 500) {
      await new Promise(resolve => setTimeout(resolve, time))
    },
    loading (container) {
      this.loader = this.$loading.show({
        container: container,
        backgroundColor: 'rgba(255,255,255,0.7)',
        canCancel: false,
        width: 40,
        height: 40
      })
    },
    handleClickViewVideo (item) {
      if (item.isTargetPremium && this.isBasicPlan) {
        this.$emit('openUpgradePlanModal')
        return false
      }
      this.handleChangeCategory('TOP')
      this.$router.push({
        name: 'VideoPlayer',
        params: {
          id: item.id
        }
      })
    },
    scrollChips (amount) {
      const el = this.$refs.chipScroll
      el.scrollBy({ left: amount, behavior: 'smooth' })
      setTimeout(this.handleScroll, 300)
    },
    handleScroll () {
      const el = this.$refs.chipScroll
      this.atStart = el.scrollLeft > 0
      this.atEnd = el.scrollLeft + el.clientWidth <= el.scrollWidth - 1
    },
    async handleChangeCategory (id) {
      this.loading(this.$refs.otherList)
      this.categoryVideoOthers = []
      await this.sleep()
      this.selectedCategory = id
      if (id === 'TOP') {
        this.categoryVideoOthers = this.topVideos
        this.loader && this.loader.hide()
        return
      }
      this.categoryVideoOthers = this.videos.filter(v => { return v.category === Number(id) })
      this.loader && this.loader.hide()
    }
  },
  watch: {
    videoId () {
      this.$nextTick(() => {
        const activeEl = this.$refs.activeVideo[0]
        if (activeEl && activeEl.scrollIntoView) {
          activeEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      })
    }
  }
}
</script>
<style scoped>
.play-list {
  min-width: 260px;
  max-height: 100%;

  border: 1px solid #ccc;
  border-radius: 8px;

  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;

  position: relative;
  padding-top: unset;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 10px;
  }

  .category-title {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    padding: 15px;
    font-size: 20px;
    font-weight: bold;
    background: #fff;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    z-index: 3;
    p {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin: unset;
    }
  }

  .play-list-card {
    display: flex;
    text-decoration: none;
    color: inherit;
    padding: 6px 15px;
    cursor: pointer;
  }

  .play-list-card img {
    width: 120px;
    height: 68px;
    object-fit: cover;
    border-radius: 4px;
    flex-shrink: 0;
  }

  .play-list-card.active {
    background-color: #dde3ebf2;
  }

  .play-list-info {
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  .play-list-title {
    font-size: 14px;
    font-weight: 500;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

@media screen and (max-width: 1024px) {
  .player-container {
    flex-direction: column;
  }

  .main-video,
  .play-list {
    width: 100%;
    flex: none;
  }

  .play-list-card {
    flex-direction: row;
  }

  .play-list-card img {
    width: 100px;
    height: 56px;
  }
}

.premium-badge {
  top: 0;
  left: 0;
  font-size: 8px;
  padding: 5px;
}

.other-list {
  width: 100%;
  min-height: 300px;
  max-height: 100%;
  font-size: 14px;
  color: #000;
  margin-top: 20px;
  position: relative;

  .other-list-header {
    display: flex;
    align-items: center;
    position: relative;
    gap: 4px;
  }

  .scroll-btn {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    padding: 0 8px;
    z-index: 2;
  }

  .chip-scroll-button {
    width: 30px;
    height: auto;
    font-size: 16px;
    padding: 10px;
    cursor: pointer;
  }

  .chip-scroll {
    display: flex;
    overflow-x: hidden;
    gap: 8px;
    padding: 4px 0;
    scroll-behavior: smooth;
  }

  .chip {
    min-width: 60px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 6px 14px;
    border-radius: 20px;
    background-color: #f2f2f2;
    border: none;
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    flex-shrink: 0;
  }

  .chip.active {
    background: #000;
    color: white;
  }

  .video-list {
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .video-item {
    display: flex;
    gap: 8px;
    cursor: pointer;
    .thumbnail-wrapper {
      width: 120px;
      height: 68px;
      flex-shrink: 0;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }

    }

    .video-meta {
      flex: 1;
      overflow: hidden;

      .video-title {
        font-size: 14px;
        font-weight: 500;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/RelatedVideos.vue